import React, { useEffect, useState, useRef } from 'react';
import {
  Typography,
  IconButton,
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import colors from '../theme/Colors';
import CustomSelect from '../components/CustomSelect';
import Navbar from '../components/Navbar';
import { api } from '../helpers/apiRequest';
import { toast } from 'react-toastify';
import SettingsIcon from '@mui/icons-material/Settings';
import ManagementDialog from '../components/ManagementDialog';
import ShareIcon from '@mui/icons-material/Share';
import html2canvas from 'html2canvas';
import InventoryTable from '../components/InventoryTable';
import InventorySizeRow from '../components/InventorySizeRow';
import InventoryShareDialog from '../components/InventoryShareDialog';
import EditInventoryDialog from '../components/EditInventoryDialog';
import { pageAccessList } from '../helpers/pageAccessList';
import ColorDialogTabs from '../components/ColorDialog';

const Inventory = () => {
  const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX'];
  const ENDPOINTS = {
    // getInventory: 'inventory/stocks',
    getInventory: '/inventory/getStocks1',
    addInventory: 'inventory/stock',
    getStyles: 'inventory/styles',
    getPStyles: 'inventory/pstyles',
    getParties: 'inventory/party',
    getItems: 'inventory/items',
    getcustomers: 'users/users/role/customer',
    getColors: 'inventory/colors',
    addColor: 'inventory/color',
    editInventory: '/inventory/update-stock',
    deleteInventory: '/inventory/stock-delete'
  };
  const [header, setHeader] = useState({ total_qt_in_container: 0, total_qt_in_hand: 0, total_qt: 0 });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [styles, setStyles] = useState([]);
  const [pStyles, setPStyles] = useState([]);
  const [parties, setParties] = useState([]);
  const [item, setItems] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [editData, setEditData] = useState({
    party: '',
    p_style: '',
    style: '',
    item: '',
    weight: '',
    label: '',
    sizes: []
  });
  const [openEditForm, setOpenEditForm] = useState(false);
  const [newInventory, setNewInventory] = useState({
    party: '',
    p_style: '',
    style: '',
    item: '',
    weight: '',
    label: '',
    sizes: []
  });
  const [filters, setFilters] = useState({
    customer: '',
    party: 'all',
    p_style: 'all',
    style: 'all',
    item: 'all',
    color: 'all'
  });
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecordDialog, setAddRecordDialog] = useState({
    open: false,
    type: '',
    name: '',
    party: '',
    customer: ''
  });
  const [colorOptions, setColorOptions] = useState([]);
  const [colorDialog, setColorDialog] = useState({
    open: false,
    name: ''
  });
  const [partySpecificOptions, setPartySpecificOptions] = useState({
    pStyles: [],
    styles: [],
    items: []
  });
  const [managementDialogOpen, setManagementDialogOpen] = useState(false);
  const [managementType, setManagementType] = useState('party');
  const [shareDialog, setShareDialog] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [previewImage, setPreviewImage] = useState('');
  const tableRef = useRef(null);
  const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [accessControl, setAccessControl] = useState({});
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const fetchCurrentUser = async () => {
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);

      if (user) {
        const res = await api.get(`/users/get/routes?userId=${userInfo?.id}`);
        const accessArray = res.data.message || [];
        // Map route permissions by route key
        const accessMapFromServer = accessArray.reduce((map, item) => {
          map[item.route] = item.allowed;
          return map;
        }, {});

        // Merge with full pageAccessList to ensure all routes are covered
        const accessMap = pageAccessList.reduce((acc, page) => {
          acc[page.key] = accessMapFromServer[page.key] || false;
          return acc;
        }, {});
        console.log("setAccessControl", accessControl);
        setAccessControl(accessMap);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchCurrentUser();
  }, []);
  const HEADER_DATA = {
    pStyle: filters.p_style !== 'all'
      ? pStyles.find(p => p._id === filters.p_style)?.name || "All P-STYLE"
      : selectedRecord?.p_style?.name || "All P-STYLE",

    style: filters.style !== 'all'
      ? styles.find(s => s._id === filters.style)?.name || "All STYLE"
      : selectedRecord?.style?.name || "All STYLE",

    item: filters.item !== 'all'
      ? item.find(i => i._id === filters.item)?.name || "All ITEM"
      : selectedRecord?.item?.name || "All ITEM",

    party: filters.party !== 'all'
      ? parties.find(p => p._id === filters.party)?.name || "All PARTY"
      : selectedRecord?.party?.name || "All PARTY",

    tsh: selectedRecord?.tsh || "",
    total_qt_in_container: selectedRecord?.total_qt_in_container || "",
    total_qt_in_hand: selectedRecord?.total_qt_in_hand || "",
    total_qt: selectedRecord?.total_qt || ""
  };

  const userRole = JSON.parse(localStorage.getItem('user'))?.role;
  const handleDelete = async (party, p_style, item, color, index) => {
    try {
      console.log("{party, p_style, item, color, index}:",party, p_style, item, color, index);
      const response = await api.delete(`${ENDPOINTS.deleteInventory}`, {
        params: {
          party: party,
          p_style: p_style,
          item: item,
          color,
        },
      });
      toast.success("Stock has been deleted Successfully!!!");
      handleEditRemoveSize(index);
      fetchInventory();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  const handleFilterChange = async (key, value) => {
    console.log("key, value", key, value);
    setFilters((prev) => ({ ...prev, [key]: value }));
  
    if (key === "party" && value !== "all") {
      try {
        const [pStylesRes, stylesRes] = await Promise.all([
          api.get(`inventory/pstyles_party?party=${value}`),
          api.get(`inventory/styles_party?party=${value}`)
        ]);
  
        // Items: only by party first (since p_style reset happens)
        const itemsRes = await api.get(`inventory/items_party?party=${value}`);
  
        setPStyles(pStylesRes.data.message || []);
        setStyles(stylesRes.data.message || []);
        setItems(itemsRes.data.message || []);
  
        // Reset dependent filters when party changes
        setFilters((prev) => ({
          ...prev,
          p_style: "all",
          style: "all",
          item: "all"
        }));
      } catch (error) {
        console.error("Error fetching party-specific options:", error);
        toast.error("Error fetching options for selected party");
      }
    } else if (key === "p_style" && value !== "all") {
      try {
        // Fetch items filtered by both party & selected p_style
        const itemsRes = await api.get(
          `inventory/items_party?party=${filters.party}&pstyle=${value}`
        );
  
        setItems(itemsRes.data.message || []);
  
        // Reset item when p_style changes
        setFilters((prev) => ({
          ...prev,
          item: "all"
        }));
      } catch (error) {
        console.error("Error fetching items for selected p_style:", error);
        toast.error("Error fetching items for selected p_style");
      }
    } else if (key === "party" && value === "all") {
      fetchDropdownData();
      setFilters((prev) => ({
        ...prev,
        p_style: "all",
        style: "all",
        item: "all"
      }));
    }
  };
  
  // const handleFilterChange = async (key, value) => {
  //   console.log("key, value", key, value)
  //   setFilters((prev) => ({ ...prev, [key]: value }));

  //   if (key === 'party' && value !== 'all') {
  //     try {
  //       const [pStylesRes, stylesRes, itemsRes] = await Promise.all([
  //         api.get(`inventory/pstyles_party?party=${value}`),
  //         api.get(`inventory/styles_party?party=${value}`),
  //         api.get(`inventory/items_party?party=${value}`)
  //       ]);

  //       setPStyles(pStylesRes.data.message || []);
  //       setStyles(stylesRes.data.message || []);
  //       setItems(itemsRes.data.message || []);

  //       setFilters(prev => ({
  //         ...prev,
  //         p_style: 'all',
  //         style: 'all',
  //         item: 'all'
  //       }));
  //     } catch (error) {
  //       console.error('Error fetching party-specific options:', error);
  //       toast.error('Error fetching options for selected party');
  //     }
  //   } else if (key === 'party' && value === 'all') {
  //     fetchDropdownData();
  //     setFilters(prev => ({
  //       ...prev,
  //       p_style: 'all',
  //       style: 'all',
  //       item: 'all'
  //     }));
  //   }
  // };
  const [dropdownsLoading, setDropdownsLoading] = useState(true);
  const fetchDropdownData = async () => {
    try {
      setDropdownsLoading(true);
      const [customersRes, partiesRes, colorsRes] = await Promise.all([
        api.get(ENDPOINTS.getcustomers),
        api.get(ENDPOINTS.getParties),
        api.get(ENDPOINTS.getColors)
      ]);

      const customersList = customersRes.data.data;
      const colorsList = colorsRes?.data?.message || [];

      setNewInventory(prev => ({
        ...prev,
        sizes: colorsList.map(color => ({
          color: color.name,
          S: '',
          M: '',
          L: '',
          XL: '',
          '2XL': '',
          MIX: ''
        }))
      }));

      setCustomers(customersList);
      setParties(partiesRes.data.message);
      setColorOptions(colorsList);

      setPStyles([]);
      setStyles([]);
      setItems([]);

      if (customersList.length > 0) {
        const firstCustomerId = customersList[0]._id;
        // setFilters(prev => ({ ...prev, customer: firstCustomerId }));
        setNewInventory(prev => ({ ...prev, customer: firstCustomerId }));
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    } finally {
      setDropdownsLoading(false);
    }
  };
  const fetchInventory = async (filtersOverride = filters) => {
    try {
      // Only proceed if customer is selected
      // if (!filters.customer) {
      //   setInventory([]);
      //   setSelectedRecord(null);
      //   return;
      // }

      const queryParams = new URLSearchParams();
      // queryParams.append('customer', filters.customer);

      if (filtersOverride.party !== 'all') queryParams.append('party', filtersOverride.party);
      if (filtersOverride.p_style !== 'all') queryParams.append('p_style', filtersOverride.p_style);
      if (filtersOverride.style !== 'all') queryParams.append('style', filtersOverride.style);
      if (filtersOverride.item !== 'all') queryParams.append('item', filtersOverride.item);
      if (filtersOverride.color !== 'all') queryParams.append('color', filtersOverride.color);

      const response = await api.get(`${ENDPOINTS.getInventory}?${queryParams.toString()}`);
      // const data = response?.data?.data || [];
      // console.log("data is here:", data);
      // setInventory(data);
      const data = response?.data?.data || [];

      // Sort by party name (case-insensitive, trimmed)
      const sortedData = [...data].sort((a, b) =>
        a.party.trim().localeCompare(b.party.trim(), undefined, { sensitivity: 'base' })
      );

      console.log("sorted data:", sortedData);
      setInventory(sortedData);
      setHeader({ total_qt_in_container: response?.data?.total_qt_in_container, total_qt_in_hand: response?.data?.total_qt_in_hand, total_qt: response?.data?.total_qt });
      setTotalPages(Math.ceil(response?.data?.total_count / rowsPerPage));
      console.log("inventory is here:", inventory);

      if (data.length === 1) {
        setSelectedRecord(data[0]);
      } else if (data.length > 1) {
        const activeFilters = Object.entries(filters).filter(([key, value]) =>
          key !== 'customer' && value !== 'all'
        ).length;

        if (activeFilters >= 2) {
          const filteredData = data.filter(record =>
            (!filters.party || filters.party === 'all' || record.party === filters.party) &&
            (!filters.p_style || filters.p_style === 'all' || record.p_style === filters.p_style) &&
            (!filters.style || filters.style === 'all' || record.style === filters.style) &&
            (!filters.item || filters.item === 'all' || record.item === filters.item)
          );

          if (filteredData.length === 1) {
            setSelectedRecord(filteredData[0]);
          } else {
            setSelectedRecord(null);
          }
        } else {
          setSelectedRecord(null);
        }
      } else {
        setSelectedRecord(null);
      }
    } catch (error) {
      console.error('Error fetching inventory:', error);
      setInventory([]);
      setSelectedRecord(null);
    }
  };



  const handleOpenDialog = () => {
    setNewInventory({
      party: '',
      p_style: '',
      style: '',
      item: '',
      weight: '',
      label: '',
      sizes: []
    });
    fetchDropdownData();
    setOpenDialog(true);
  };


  const handleRemoveSize = (index) => {
    setNewInventory(prev => ({
      ...prev,
      sizes: prev.sizes.filter((_, i) => i !== index)
    }));
  };
  const handleEditRemoveSize = (index) => {
    setEditData(prev => ({
      ...prev,
      sizes: prev.sizes.filter((_, i) => i !== index)
    }));
    console.log("The Edit data is now:", editData);
  };
  const handleSizeChange = (index, field, value) => {
    setNewInventory(prev => ({
      ...prev,
      sizes: prev.sizes.map((size, i) => {
        if (i === index) {
          return { ...size, [field]: value };
        }
        return size;
      })
    }));
  };
  const handleEditSizeChange = (index, field, value) => {
    setEditData(prev => ({
      ...prev,
      sizes: prev.sizes.map((size, i) => {
        if (i === index) {
          return { ...size, [field]: value };
        }
        return size;
      })
    }));
  };

  const handleAddInventory = async () => {
    try {
      const requiredFields = {
        party: 'Party',
        p_style: 'P-Style',
        // style: 'Style',
        item: 'Item',
        // weight: 'Weight',
        // label: 'Label'
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([key]) => !newInventory[key])
        .map(([_, label]) => label);

      if (missingFields.length > 0) {
        toast.error(`Please select ${missingFields.join(', ')}`);
        return;
      }

      const processedSizes = newInventory.sizes
        .filter(size => {
          return sizes.some(sizeOption =>
            parseInt(size[sizeOption]) > 0
          );
        })
        .map(size => {
          const totalQuantity = sizes.reduce((sum, sizeOption) => {
            return sum + (parseInt(size[sizeOption]) || 0);
          }, 0);

          return {
            ...size,
            quantity_in_hand: totalQuantity || 0,
            quantity_in_container: 0,
            S: parseInt(size.S) || 0,
            M: parseInt(size.M) || 0,
            L: parseInt(size.L) || 0,
            XL: parseInt(size.XL) || 0,
            '2XL': parseInt(size['2XL']) || 0,
            MIX: parseInt(size.MIX) || 0
          };
        });

      if (processedSizes.length === 0) {
        toast.error('Please enter at least one size quantity');
        return;
      }

      const response = await api.post(ENDPOINTS.addInventory, {
        ...newInventory,
        sizes: processedSizes
      });

      if (response.data.status) {
        toast.success('Inventory added successfully');
        fetchInventory();
        handleCloseDialog();
      } else {
        toast.error('Failed to add inventory');
      }
    } catch (error) {
      toast.error('Error adding inventory');
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewInventory((prev) => ({ ...prev }))
  };

  const handleOpenAddRecordDialog = (type) => {
    setAddRecordDialog({
      open: true,
      type,
      name: '',
      party: '',
      customer: ''
    });
  };

  const handleCloseAddRecordDialog = () => {
    setAddRecordDialog({
      open: false,
      type: '',
      name: '',
      party: '',
      customer: ''
    });
  };
  const handleEditRecord = async () => {
    try {
      console.log("editData:", editData);
      const requiredFields = {
        party: 'Party',
        p_style: 'P-Style',
        item: 'Item',
        // weight: 'Weight',
        // label: 'Label'
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([key]) => !editData[key])
        .map(([_, label]) => label);

      if (missingFields.length > 0) {
        toast.error(`Please select ${missingFields.join(', ')}`);
        return;
      }
      const processedSizes = editData.sizes
        .filter(size => {
          return sizes.some(sizeOption =>
            parseInt(size[sizeOption]) > 0
          );
        })
        .map(size => {
          const totalQuantity = sizes.reduce((sum, sizeOption) => {
            return sum + (parseInt(size[sizeOption]) || 0);
          }, 0);

          return {
            ...size,
            quantity_in_hand: totalQuantity || 0,
            quantity_in_container: 0,
            S: parseInt(size.S) || 0,
            M: parseInt(size.M) || 0,
            L: parseInt(size.L) || 0,
            XL: parseInt(size.XL) || 0,
            '2XL': parseInt(size['2XL']) || 0,
            MIX: parseInt(size.MIX) || 0
          };
        });

      if (processedSizes.length === 0) {
        toast.error('Please enter at least one size quantity');
        return;
      }
      const response = await api.put(`${ENDPOINTS.editInventory}`, {
        ...editData,
        sizes: processedSizes
      });

      if (response.data.status) {
        toast.success('Inventory Updated successfully');
        fetchInventory();
        setOpenEditForm(false);
        setOpenEditDialog(false);
      } else {
        toast.error('Failed to add inventory');
      }
    } catch (error) {

    }

  }
  const handleCloseInventoryEdit = () => {
    setOpenEditDialog(false);
  }
  const handleAddRecord = async () => {
    if (!addRecordDialog.name.trim()) {
      toast.warn('Name cannot be empty.');
      return;
    }

    if (addRecordDialog.type === 'party' && !addRecordDialog.customer) {
      toast.warn('Please select a customer.');
      return;
    }
    if (openEditDialog) {
      if (['style', 'pStyle', 'item'].includes(addRecordDialog.type) && !editData.party) {
        toast.warn('Please select a party.');
        return;
      }
    } else {
      if (['style', 'pStyle', 'item'].includes(addRecordDialog.type) && !newInventory.party) {
        toast.warn('Please select a party.');
        return;
      }
    }
    // if (['style', 'pStyle', 'item'].includes(addRecordDialog.type) && !addRecordDialog.party) {
    //   console.log("addRecordDialog:",addRecordDialog);
    //   toast.warn('Please select a party.');
    //   return;
    // }

    try {
      const endpoints = {
        party: 'inventory/party',
        pStyle: 'inventory/p-style',
        style: 'inventory/style',
        item: 'inventory/item'
      };

      let payload;
      if (addRecordDialog.type === 'party') {
        payload = {
          name: addRecordDialog.name,
          customer: addRecordDialog.customer
        };
      } else if (['style', 'pStyle', 'item'].includes(addRecordDialog.type)) {
        payload = {
          name: addRecordDialog.name,
          party: editData?.party ? editData?.party : newInventory.party
        };
      } else {
        payload = {
          name: addRecordDialog.name
        };
      }

      const response = await api.post(endpoints[addRecordDialog.type], payload);

      if (response.status === 200 || response.OK) {
        toast.success('Added successfully');
        fetchDropdownData();
        if (openEditDialog) {
          fetchPartySpecificOptions(editData?.party);
        } else if (newInventory?.party) {
          fetchPartySpecificOptions(newInventory?.party);
        }
        handleCloseAddRecordDialog();
      }
      // handleCloseAddRecordDialog();

    } catch (error) {
      toast.error('Failed to add record. Please try again.');
      console.error('Error adding record:', error);
    } finally {
      fetchDropdownData();
    }
  };

  const handleOpenColorDialog = () => {
    setColorDialog({
      open: true,
      name: ''
    });
  };

  const handleCloseColorDialog = () => {
    setColorDialog({
      open: false,
      name: ''
    });
  };

  const handleAddColor = async () => {
    if (!colorDialog.name.trim()) {
      toast.warn('Color name cannot be empty.');
      return;
    }

    try {
      const response = await api.post(ENDPOINTS.addColor, {
        name: colorDialog.name
      });

      if (response.status === 200 || response.OK) {
        toast.success('Color added successfully');

        const colorsRes = await api.get(ENDPOINTS.getColors);
        const newColors = colorsRes.data.message || [];
        setColorOptions(newColors);


        if (openEditForm) {
          // setEditData(prev => ({
          //   ...prev,
          //   sizes: [
          //     ...prev.sizes,
          //     {
          //       color: colorDialog.name,
          //       S: '',
          //       M: '',
          //       L: '',
          //       XL: '',
          //       '2XL': '',
          //       MIX: ''
          //     }
          //   ]
          // }));
          setEditData(prev => ({
            ...prev,
            sizes: [
              ...prev.sizes,
              {
                color: colorDialog.name,
                ...sizes.reduce((acc, size) => {
                  acc[size] = ''; // initialize each size with empty string
                  return acc;
                }, {})
              }
            ]
          }));
        } else {
          // setNewInventory(prev => ({
          //   ...prev,
          //   sizes: [
          //     ...prev.sizes,
          //     {
          //       color: colorDialog.name,
          //       S: '',
          //       M: '',
          //       L: '',
          //       XL: '',
          //       '2XL': '',
          //       MIX: ''
          //     }
          //   ]
          // }));
          setNewInventory(prev => ({
            ...prev,
            sizes: [
              ...prev.sizes,
              {
                color: colorDialog.name,
                ...sizes.reduce((acc, size) => {
                  acc[size] = ''; // initialize each size with empty string
                  return acc;
                }, {})
              }
            ]
          }));
        }

        handleCloseColorDialog();
      }
    } catch (error) {
      toast.error('This color Already Exists in the System.');
      console.error('This color Already Exists in the System');
    }
  };

  // const fetchPartySpecificOptions = async (partyId) => {
  //   try {
  //     if (partyId) {
  //       const [pStylesRes, itemsRes] = await Promise.all([
  //         api.get(`inventory/pstyles_party?party=${partyId}`),
  //         api.get(`inventory/items_party?party=${partyId}`)
  //       ]);

  //       setPartySpecificOptions({
  //         pStyles: pStylesRes.data.message || [],
  //         // styles: stylesRes.data.message || [],
  //         items: itemsRes.data.message || []
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching party-specific options:', error);
  //     toast.error('Error fetching options for selected party');
  //   }
  // };
  const fetchPartySpecificOptions = async (partyId, pStyleId = null) => {
    try {
      if (partyId) {
        // Always fetch pStyles for the selected party
        const pStylesRes = await api.get(`inventory/pstyles_party?party=${partyId}`);
  
        let itemsRes;
        if (pStyleId) {
          // Fetch items by both party and selected pStyle
          itemsRes = await api.get(`inventory/items_party?party=${partyId}&pstyle=${pStyleId}`);
        } else {
          // Fetch items only by party
          itemsRes = await api.get(`inventory/items_party?party=${partyId}`);
        }
  
        setPartySpecificOptions({
          pStyles: pStylesRes.data.message || [],
          items: itemsRes.data.message || []
        });
      }
    } catch (error) {
      console.error("Error fetching party-specific options:", error);
      toast.error("Error fetching options for selected party");
    }
  };
  
  // Update the party selection handler
  const handlePartyChange = async (value) => {
    // Reset dependent fields
    console.log("party gonna change:", value);
    setNewInventory(prev => ({
      ...prev,
      party: value,
      p_style: '',
      style: '',
      item: ''
    }));
    setAddRecordDialog(prev => ({ ...prev, party: value }));
    if (openEditForm) {
      setEditData(prev => ({
        ...prev,
        party: value,
        p_style: '',
        style: '',
        item: ''
      }));
    }
    if (value) {
      await fetchPartySpecificOptions(value);
    } else {
      setPartySpecificOptions({
        pStyles: [],
        styles: [],
        items: []
      });
    }
  };

  const handleOpenManagementDialog = (type) => {
    setManagementType(type);
    setManagementDialogOpen(true);
  };

  // const handleOpenShareDialog = async () => {
  //   try {
  //     const canvas = await html2canvas(tableRef.current);
  //     const image = canvas.toDataURL('image/png');
  //     setPreviewImage(image);
  //     setShareDialog(true);
  //   } catch (error) {
  //     console.error('Error generating preview:', error);
  //     toast.error('Error generating preview');
  //   }
  // };
  // const handleOpenShareDialog = async () => {
  //   try {
  //     if (!tableRef.current) throw new Error("tableRef is null");

  //     const el = tableRef.current;

  //     const fullWidth = el.scrollWidth;   // full table width
  //     const fullHeight = el.scrollHeight; // full table height

  //     const canvas = await html2canvas(el, {
  //       backgroundColor: "#fff",
  //       useCORS: true,
  //       scale: Math.min(window.devicePixelRatio, 2),
  //       width: fullWidth,
  //       height: fullHeight,
  //       windowWidth: fullWidth,   // 👈 tell it to render entire scrollable width
  //       windowHeight: fullHeight, // 👈 entire scrollable height
  //       scrollX: 0,
  //       scrollY: 0,
  //       logging: false,
  //     });

  //     const image = canvas.toDataURL("image/png");
  //     setPreviewImage(image);
  //     setShareDialog(true);
  //   } catch (error) {
  //     console.error("Error generating preview:", error);
  //     toast.error("Error generating preview");
  //   }
  // };
  const handleOpenShareDialog = async () => {
    try {
      if (!tableRef.current) throw new Error("tableRef is null");

      const el = tableRef.current;

      // get full size of table (even hidden/overflow parts)
      const fullWidth = el.scrollWidth;
      const fullHeight = el.scrollHeight;

      // temporarily force the element to be fully visible for capture
      const originalStyle = {
        width: el.style.width,
        height: el.style.height,
        overflow: el.style.overflow,
      };

      el.style.width = fullWidth + "px";
      el.style.height = fullHeight + "px";
      el.style.overflow = "visible";

      const canvas = await html2canvas(el, {
        backgroundColor: "#fff",
        useCORS: true,
        scale: 2,               // sharp image
        width: fullWidth,
        height: fullHeight,
        windowWidth: fullWidth,
        windowHeight: fullHeight,
        scrollX: 0,
        scrollY: 0,
        logging: false,
      });

      // restore styles
      el.style.width = originalStyle.width;
      el.style.height = originalStyle.height;
      el.style.overflow = originalStyle.overflow;

      const image = canvas.toDataURL("image/png");
      setPreviewImage(image);
      setShareDialog(true);
    } catch (error) {
      console.error("Error generating preview:", error);
      toast.error("Error generating preview");
    }
  };




  const handleShare = async () => {
    if (!selectedCustomer) {
      toast.error('Please select a customer');
      return;
    }

    try {
      // Convert base64 to blob
      const base64Response = await fetch(previewImage);
      const blob = await base64Response.blob();

      // Create file from blob
      const file = new File([blob], 'inventory.png', { type: 'image/png' });

      const formData = new FormData();
      formData.append('image', file);
      formData.append('userId', selectedCustomer);
      formData.append('type', "Inventory");
      const response = await api.post('inventory/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        toast.success('Inventory shared successfully');
        setShareDialog(false);
        setSelectedCustomer('');
        setPreviewImage('');
      } else {
        toast.error('Failed to share inventory');
      }
    } catch (error) {
      console.error('Error sharing inventory:', error);
      toast.error('Error sharing inventory');
    }
  };
  useEffect(() => {

  }, [openEditForm]);
  const filtersRef = useRef(filters);

  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);
  const transformInventoryDataToEditData = (inventoryItems) => {
    if (!Array.isArray(inventoryItems) || inventoryItems.length === 0) return;

    const firstItem = inventoryItems[0];

    // build rows for each color
    const sizes = inventoryItems.map(item => {
      const sizeMap = {};
      item.sizes.forEach(size => {
        sizeMap[size.size] = size.quantity_in_hand;
      });

      return {
        color: item.color,
        ...sizeMap
      };
    });

    const transformed = {
      // if you don't have _id, just skip it
      party: firstItem?.party?._id || "",
      p_style: firstItem?.p_style?._id || "",
      item: firstItem?.item?._id || "",
      weight: firstItem?.weight || "", // add only if your data has it
      label: firstItem?.label || "",   // add only if your data has it
      sizes // array of { color, S, M, L, XL, etc. }
    };

    console.log("✅ Transformed Edit Data:", transformed);
    return transformed;
  };
  useEffect(() => {

    const interval = setInterval(() => {
      fetchInventory(filtersRef.current); // Pass the latest filters from the ref
    }, 10000);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (userInfo) {
      fetchDropdownData();
    }
  }, [userInfo]);
  useEffect(() => {
    // if (filters.customer) 
    fetchInventory();
  }, [filters]);
  useEffect(() => {


  }, [editData])
  useEffect(() => {
    const fetchOptions = async () => {
      await fetchPartySpecificOptions(editData?.party?.id);
    }
    fetchOptions();

  }, [openEditForm]);
  const handleOpenEditDialog = (data) => {
    setOpenEditForm(true);
    // setEditData(data);
    // const transformed = transformInventoryDataToEditData(data);
    // setEditData(transformed);
    // fetchPartySpecificOptions(transformed?.party?.id);
  }
  // new 
  const sizeGroups = {
    S: ["6M", "2Y"],
    M: ["12M", "4Y"],
    L: ["12M", "6Y"],
  };
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Up to 600px
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md')); // Up to 900px
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: { xs: 1, sm: 2, md: 3 }, // Responsive padding
        width: '90%',
        maxWidth: '1600px', // Max width for content on large screens
        margin: '0 auto', // Center the content
      }}
    >
      <Navbar title='Inventory' />
      <Box
        sx={{
          marginTop: { xs: 8, sm: 10 }, // Adjust top margin for fixed Navbar
          marginBottom: { xs: 2, sm: 3 },
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' }, // Stack on small, row on medium/large
          alignItems: { xs: 'flex-start', md: 'flex-start' },
          gap: { xs: 2, sm: 3 }, // Gap between filter group and buttons
          justifyContent: 'space-between',
        }}
      >
        {/* Filter Selection Box */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap', // Allow filters to wrap
            gap: { xs: 1, sm: 1.5, md: 2 }, // Responsive gap between individual filters
            width: { xs: '100%', md: 'auto' }, // Full width on small, auto on medium/large
            justifyContent: { xs: 'center', sm: 'flex-start' }, // Center on xs, align left on sm+
            maxWidth: { xs: '100%', md: '70%' }, // Limit width on larger screens to make space for buttons
            flexGrow: 1, // Allow filters to grow
          }}
        >
          <CustomSelect
            label="Filter by Party"
            value={filters.party}
            key={parties.length}
            onChange={(e) => handleFilterChange('party', e.target.value)}
            options={[
              { id: 'all', name: 'All Parties' },
              ...parties.map((p) => ({ id: p._id, name: p.name }))
            ]}
            sx={{
              minWidth: { xs: 'calc(50% - 8px)', sm: 180, md: 200 }, // Two columns on xs, wider on sm+
              flexGrow: 1,
            }}
            InputLabelProps={{ shrink: true }}
            size={isSmallScreen ? "small" : "medium"} // Smaller input on small screens
          />
          <CustomSelect
            label="Filter by P Style/Style"
            value={filters.p_style}
            onChange={(e) => handleFilterChange('p_style', e.target.value)}
            options={[
              { id: 'all', name: 'All P Styles/Styles' },
              ...pStyles.map((p) => ({ id: p._id, name: p.name }))
            ]}
            sx={{
              minWidth: { xs: 'calc(50% - 8px)', sm: 180, md: 200 },
              flexGrow: 1,
            }}
            size={isSmallScreen ? "small" : "medium"}
          />
          <CustomSelect
            label="Filter by Item"
            value={filters.item}
            onChange={(e) => handleFilterChange('item', e.target.value)}
            options={[
              { id: 'all', name: 'All Items' },
              ...item.map((i) => ({ id: i._id, name: i.name }))
            ]}
            sx={{
              minWidth: { xs: 'calc(50% - 8px)', sm: 180, md: 200 },
              flexGrow: 1,
            }}
            size={isSmallScreen ? "small" : "medium"}
          />
          <CustomSelect
            label="Filter by Color"
            value={filters.color}
            onChange={(e) => handleFilterChange('color', e.target.value)}
            options={[
              { id: 'all', name: 'All Colors' },
              ...colorOptions.map((color) => ({
                id: color.name,
                name: color.name || color
              }))
            ]}
            sx={{
              minWidth: { xs: 'calc(50% - 8px)', sm: 180, md: 200 },
              flexGrow: 1,
            }}
            size={isSmallScreen ? "small" : "medium"}
          />
        </Box>

        {/* Action Buttons Box */}
        {(userRole === 'admin' || accessControl["manage-inventory"] === true) && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'row', sm: 'row', md: 'column' }, // Row on xs/sm, column on md+
              gap: { xs: 1, sm: 1.5 }, // Smaller gap when in a row, larger when stacked
              flexWrap: { xs: 'wrap', md: 'nowrap' }, // Wrap on xs/sm, no wrap on md+
              justifyContent: { xs: 'center', sm: 'flex-end', md: 'flex-start' }, // Center on xs, end on sm, start on md
              width: { xs: '100%', md: 'auto' }, // Full width on small, auto on medium/large
              mt: { xs: 2, md: 0 }, // Top margin on small, none on medium/large
              alignItems: 'center',
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: colors.primary,
                color: 'black',
                '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                width: { xs: 'calc(50% - 8px)', sm: 'auto' }, // Two buttons per row on xs
                flexGrow: { xs: 1, sm: 0 },
                minHeight: { xs: '40px', sm: '48px' },
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
              startIcon={<AddIcon />}
              onClick={handleOpenDialog}
            >
              Add Inventory
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: colors.primary,
                color: 'black',
                '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                width: { xs: 'calc(50% - 8px)', sm: 'auto' },
                flexGrow: { xs: 1, sm: 0 },
                minHeight: { xs: '40px', sm: '48px' },
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
              startIcon={<EditIcon />}
              onClick={handleOpenEditDialog}
            >
              Edit Inventory
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: colors.primary,
                color: 'black',
                '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                width: { xs: 'calc(100% - 8px)', sm: 'auto' }, // Full width on xs for this button
                flexGrow: { xs: 1, sm: 0 },
                minHeight: { xs: '40px', sm: '48px' },
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
              startIcon={<ShareIcon />}
              onClick={handleOpenShareDialog}
            >
              Share Report
            </Button>
          </Box>
        )}
      </Box>

      {/* Inventory Table */}
      <Box ref={tableRef} sx={{ overflowX: 'auto', mt: 2 }}> {/* Enable horizontal scroll for table */}
        <InventoryTable
          inventory={inventory}
          headerData={HEADER_DATA}
          header={header}
          setEditData={handleOpenEditDialog}
          handleDelete={handleDelete}
        />
      </Box>

      {/* Edit Inventory Dialog */}
      <EditInventoryDialog
        openEditForm={openEditForm}
        setOpenEditForm={setOpenEditForm}
        editData={editData}
        setEditData={setEditData}
        parties={parties}
        partySpecificOptions={partySpecificOptions}
        sizeOptions={sizes}
        colors={colors}
        handleOpenAddRecordDialog={handleOpenAddRecordDialog}
        handleOpenManagementDialog={handleOpenManagementDialog}
        handlePartyChange={handlePartyChange}
        handleOpenColorDialog={handleOpenColorDialog}
        handleEditSizeChange={handleEditSizeChange}
        // handleEditRemoveSize={handleEditRemoveSize}
        handleEditRemoveSize={handleDelete}
        handleEditRecord={handleEditRecord}
        transformInventoryDataToEditData={transformInventoryDataToEditData}
      />

      {/* Inventory Share Dialog */}
      <InventoryShareDialog
        open={shareDialog}
        handleClose={() => {
          setShareDialog(false);
          setPreviewImage('');
          setSelectedCustomer('');
        }}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        customers={customers}
        previewImage={previewImage}
        handleShare={handleShare}
      />

      {/* Add Inventory Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: { xs: '90vh', sm: '70vh' },
            maxHeight: '90vh',
            width: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 32px)', md: '80%' },
            margin: { xs: 1, sm: 2 },
            padding: { xs: '10px', sm: '16px' },
          }
        }}
      >
        <DialogTitle
          sx={{
            fontSize: { xs: '1.2rem', sm: '1.4rem' },
            fontWeight: 'bold',
            pb: 0.5,
            pr: { xs: 5, sm: 8 } // Add right padding for close button
          }}
        >
          Add Inventory
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: { xs: 8, sm: 16 },
              top: { xs: 8, sm: 16 },
              color: 'black'
            }}
          >
            ×
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            pt: 1,
            pb: 1,
            overflowY: 'auto', // Enable vertical scrolling for content
            '&::-webkit-scrollbar': {
              width: '8px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#bdbdbd',
              borderRadius: '4px'
            }
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.5, sm: 2 }, mt: 2 }}>
            {/* First row */}
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // Stack on xs, row on sm+
              gap: { xs: 1.5, sm: 2 },
              alignItems: 'center',
            }}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <CustomSelect
                  label="Party"
                  value={newInventory.party}
                  onChange={(e) => handlePartyChange(e.target.value)}
                  options={parties.map(party => ({
                    id: party._id,
                    name: party.name
                  }))}
                  sx={{ flex: 1 }}
                  size={isSmallScreen ? "small" : "medium"}
                />
                <IconButton
                  onClick={() => handleOpenAddRecordDialog('party')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                    '&.Mui-disabled': { backgroundColor: '#e0e0e0' }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Add Party">
                    <AddIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
                <IconButton
                  onClick={() => handleOpenManagementDialog('party')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Management">
                    <SettingsIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <CustomSelect
                  label="P Style/Style"
                  value={newInventory.p_style}
                  onChange={(e) => setNewInventory({ ...newInventory, p_style: e.target.value })}
                  options={partySpecificOptions?.pStyles?.map(style => ({
                    id: style._id, name: style.name
                  }))}
                  sx={{ flex: 1 }}
                  disabled={!newInventory.party}
                  size={isSmallScreen ? "small" : "medium"}
                />
                <IconButton
                  onClick={() => handleOpenAddRecordDialog('pStyle')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                    '&.Mui-disabled': { backgroundColor: '#e0e0e0' }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Add pStyle">
                    <AddIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
                <IconButton
                  onClick={() => handleOpenManagementDialog('pStyle')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Management">
                    <SettingsIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
              </Box>
            </Box>

            {/* Second row */}
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // Stack on xs, row on sm+
              gap: { xs: 1.5, sm: 2 },
              alignItems: 'center',
            }}>
              {/* <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <CustomSelect
                  label="Style"
                  value={newInventory.style}
                  onChange={(e) => setNewInventory({ ...newInventory, style: e.target.value })}
                  options={partySpecificOptions.styles.map(style => ({
                    id: style._id, name: style.name
                  }))}
                  sx={{ flex: 1 }}
                  disabled={!newInventory.party}
                  size={isSmallScreen ? "small" : "medium"}
                />
                <IconButton
                  onClick={() => handleOpenAddRecordDialog('style')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                    '&.Mui-disabled': { backgroundColor: '#e0e0e0' }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Add Style">
                    <AddIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
                <IconButton
                  onClick={() => handleOpenManagementDialog('style')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Management">
                    <SettingsIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
              </Box> */}
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <CustomSelect
                  label="Item"
                  value={newInventory.item}
                  onChange={(e) => setNewInventory({ ...newInventory, item: e.target.value })}
                  options={partySpecificOptions.items.map(item => ({
                    id: item._id, name: item.name
                  }))}
                  sx={{ flex: 1 }}
                  disabled={!newInventory.party}
                  size={isSmallScreen ? "small" : "medium"}
                />
                <IconButton
                  onClick={() => handleOpenAddRecordDialog('item')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                    '&.Mui-disabled': { backgroundColor: '#e0e0e0' }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Add Item">
                    <AddIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
                <IconButton
                  onClick={() => handleOpenManagementDialog('item')}
                  sx={{
                    backgroundColor: colors.primary, '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                  }}
                  size={isSmallScreen ? "small" : "medium"}
                >
                  <Tooltip title="Management">
                    <SettingsIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                  </Tooltip>
                </IconButton>
              </Box>
            </Box>

            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // Stack on xs, row on sm+
              gap: { xs: 1.5, sm: 2 },
              alignItems: 'center',
            }}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <TextField
                  label="Weight"
                  value={newInventory.weight}
                  onChange={(e) => setNewInventory({ ...newInventory, weight: e.target.value })}
                  sx={{ flex: 1 }}
                  size={isSmallScreen ? "small" : "medium"}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, width: { xs: '100%', sm: 'auto' } }}>
                <TextField
                  label="Label"
                  value={newInventory.label}
                  onChange={(e) => setNewInventory({ ...newInventory, label: e.target.value })}
                  sx={{ flex: 1 }}
                  size={isSmallScreen ? "small" : "medium"}
                />
              </Box>
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Typography variant={isSmallScreen ? "subtitle2" : "subtitle1"} gutterBottom>
              Sizes and Details
            </Typography>

            {/* Sizes Header Row */}
            {/* <Box sx={{
              display: 'flex',
              gap: 1,
              mb: 1,
              backgroundColor: colors.primary,
              p: 1,
              textAlign: 'center',
              borderRadius: '4px',
              overflowX: 'auto', // Allow horizontal scroll for sizes header
              '& > div': {
                color: 'black',
                fontWeight: 500,
                fontSize: { xs: '0.7rem', sm: '0.9rem' },
                flex: 1,
                minWidth: '70px', // Ensure min width for each size column
              }
            }}>
              <Box sx={{ minWidth: '100px' }}>Color</Box>
              {sizes.map((size) => (
                <Box key={size}>{size}</Box>
              ))}
            </Box> */}
<Box sx={{
              display: 'flex',
              // gap: 1,
              // mb: 1,
              backgroundColor: colors.primary,
              p: 1,
              textAlign: 'center',
              borderRadius: '4px',
              overflowX: 'auto', // Allow horizontal scroll for sizes header
              '& > div': {
                color: 'black',
                fontWeight: 500,
                fontSize: { xs: '0.7rem', sm: '0.9rem' },
                flex: 1,
                minWidth: '70px', // Ensure min width for each size column
              }
            }}>
      {/* Color column */}
      <Box
  sx={{
    minWidth: "100px",
    border: "1px solid black",
    textAlign: "center",
    fontWeight: "bold",
    display: "flex",              // make it a flex container
    justifyContent: "center",     // horizontal center
    alignItems: "center",         // vertical center
  }}
      >
        Color
      </Box>

      {/* Sizes */}
      {sizes.map((size) =>
        sizeGroups[size] ? (
          // Grouped size (S, M, L)
          <Box
            key={size}
            sx={{
              display: "flex",
              flexDirection: "column",
              border: "1px solid black",
              flex: 1,
            }}
          >
            <Box sx={{ display: "flex"}}>
              {sizeGroups[size].map((child) => (
                <Box
                  key={child}
                  sx={{
                    flex: 1,
                    borderRight: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {child}
                </Box>
              ))}
            </Box>
            {/* Parent label */}
            <Box
              sx={{
                borderBottom: "1px solid black",
                borderTop:'1px solid black',
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {size==='S'?'Small':size==='M'?'Medium':size==='L'?'Large':size}
            </Box>
            {/* Children row */}
            
          </Box>
        ) : (
          // Single size (XS, XL, 2XL, 3XL)
          <Box
            key={size}
            sx={{
              minWidth: "80px",
              border: "1px solid black",
              textAlign: "center",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {size}
          </Box>
        )
      )}
    </Box>
            {/* Inventory Size Rows */}
            <Box sx={{
              mt: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              overflowY: 'auto', // Allow vertical scrolling for size rows
              maxHeight: '300px', // Limit height
            }}>
              {newInventory.sizes.map((size, index) => (
                <InventorySizeRow
                  key={index}
                  size={size}
                  index={index}

                  handleSizeChange={handleSizeChange}
                  handleRemoveSize={handleRemoveSize}
                  sizeOptions={sizes}
                  isSmallScreen={isSmallScreen} // Pass isSmallScreen for internal responsiveness
                />
              ))}

              {/* Add Color Button */}
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleOpenColorDialog}
                sx={{
                  mt: 1,
                  backgroundColor: colors.primary,
                  color: 'black',
                  alignSelf: { xs: 'center', sm: 'flex-start' }, // Center on xs, align left on sm+
                  width: { xs: '90%', sm: 'auto' }, // Full width on xs
                  '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  minHeight: { xs: '40px', sm: '48px' }
                }}
              >
                Add Color
              </Button>
              <IconButton
                onClick={() => handleOpenManagementDialog('color')}
                sx={{
                  ml: 1,
                  backgroundColor: colors.primary,
                  '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                }}
                size={isSmallScreen ? 'small' : 'medium'}
              >
                <Tooltip title="Manage Colors">
                  <SettingsIcon sx={{ color: 'black', fontSize: isSmallScreen ? 18 : 22 }} />
                </Tooltip>
              </IconButton>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{
          p: { xs: 1, sm: 1.5 }, pt: 0,
          flexDirection: { xs: 'column', sm: 'row' }, // Stack on xs, row on sm+
          gap: { xs: 1, sm: 0 }, // Gap when stacked
          justifyContent: 'flex-end',
        }}>
          <Button
            onClick={handleCloseDialog}
            sx={{
              color: 'black',
              width: { xs: '100%', sm: 'auto' }, // Full width on xs
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddInventory}
            variant="contained"
            sx={{
              backgroundColor: colors.primary,
              color: 'black',
              '&:hover': { backgroundColor: colors.primary, opacity: 0.9 },
              width: { xs: '100%', sm: 'auto' }, // Full width on xs
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Record Dialog */}
      <Dialog
        open={addRecordDialog.open}
        onClose={handleCloseAddRecordDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            margin: { xs: 1, sm: 2 },
            width: { xs: 'calc(100% - 16px)', sm: 'auto' },
            padding: { xs: '10px', sm: '16px' },
          }
        }}
      >
        <DialogTitle sx={{ fontSize: { xs: '1rem', sm: '1.2rem' } }}>
          Add New {addRecordDialog.type}
          <IconButton
            onClick={handleCloseAddRecordDialog}
            sx={{
              position: 'absolute', right: { xs: 8, sm: 16 }, top: { xs: 8, sm: 16 },
              color: 'black'
            }}
          >
            ×
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.5, sm: 2 }, mt: 1 }}>
          {addRecordDialog.type === 'party' && (
            <CustomSelect
              label="Customer"
              value={addRecordDialog.customer}
              onChange={(e) => setAddRecordDialog(prev => ({ ...prev, customer: e.target.value }))}
              options={customers.map(customer => ({
                id: customer._id,
                name: customer.name
              }))}
              fullWidth
              size={isSmallScreen ? "small" : "medium"}
            />
          )}
          {['style', 'pStyle', 'item'].includes(addRecordDialog.type) && (
            <CustomSelect
              label="Party"
              value={newInventory?.party || editData?.party || addRecordDialog.party}
              onChange={(e) => setAddRecordDialog(prev => ({ ...prev, party: e.target.value }))}
              options={parties.map(party => ({
                id: party._id,
                name: party.name
              }))}
              fullWidth
              size={isSmallScreen ? "small" : "medium"}
            />
          )}
          <TextField
            autoFocus
            label="Name"
            type="text"
            fullWidth
            value={addRecordDialog.name}
            onChange={(e) => setAddRecordDialog(prev => ({ ...prev, name: e.target.value }))}
            size={isSmallScreen ? "small" : "medium"}
          />
        </DialogContent>
        <DialogActions sx={{
          p: { xs: 1, sm: 1.5 },
          flexDirection: { xs: 'column', sm: 'row' }, // Stack on xs, row on sm+
          gap: { xs: 1, sm: 0 }, // Gap when stacked
          justifyContent: 'flex-end',
        }}>
          <Button
            onClick={handleCloseAddRecordDialog}
            sx={{
              width: { xs: '100%', sm: 'auto' },
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddRecord}
            sx={{
              backgroundColor: colors.primary,
              color: 'black',
              '&:hover': {
                backgroundColor: colors.primary,
                opacity: 0.9
              },
              width: { xs: '100%', sm: 'auto' },
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <ColorDialogTabs
        open={colorDialog.open}
        onClose={() => handleCloseColorDialog()}
        onAddColor={(newColorRow) => {
          setNewInventory(prev => ({
            ...prev,
            sizes: [...(prev.sizes || []), newColorRow]
          }));
        }}
        colorDialog={colorDialog}
        setColorDialog={setColorDialog}

        handleAddNew={handleAddColor}
        existingColors={colorOptions} // from DB or state
      />
      <ColorDialogTabs
        open={colorDialog.open}
        onClose={() => handleCloseColorDialog()}
        onAddColor={(newColorRow) => {
          openEditForm ?
            setEditData(prev => ({
              ...prev,
              sizes: [...(prev.sizes || []), newColorRow]
            }))
            :
            setNewInventory(prev => ({
              ...prev,
              sizes: [...(prev.sizes || []), newColorRow]
            }))
        }}
        colorDialog={colorDialog}
        setColorDialog={setColorDialog}
        handleAddNew={handleAddColor}
        existingColors={colorOptions} // from DB or state
      />
      <ManagementDialog
        open={managementDialogOpen}
        onClose={() => setManagementDialogOpen(false)}
        type={managementType}
        partyId={editData?.party?editData?.party:newInventory?.party}
        pstyle={editData?.p_style?editData?.p_style:newInventory?.p_style}

      />
    </Box>
  );
};

export default Inventory;
